const THUMBNAIL_SIZES = {
  '100x': 100,
  '200x': 200,
  '400x': 400,
  '800x': 800,
  '1000x': 1000,
  '2000x': 2000,
  /*
    // If both width and height is needed, could look like this:
    '400x300': { width: 400, height: 300 },

    // If only height is needed, could look like this:
    'x300': 300,
  */
} as const
export type ThumbnailSizeKey = keyof typeof THUMBNAIL_SIZES

/**
 * Returns the size information for the given thumbnail size key.
 * If the key is in the format `{width}x` or `x{height}`, it returns the corresponding number.
 * If the key is in the format `{width}x{height}`, it returns an object with width and height properties.
 *
 * @param sizeKey - The thumbnail size key.
 * @returns number | { width: number; height: number }
 */
export function useThumbnailSize<K extends ThumbnailSizeKey>(sizeKey: K): (typeof THUMBNAIL_SIZES)[K] {
  return THUMBNAIL_SIZES[sizeKey]
}
